import { useContext } from "react";
import { WindowSizeContext } from ".";

// determines viewport breakpoints
// usage: const { isMobile, isTablet, isDesktop } = useBreakpoint();
export const useBreakpoint = () => {
  let { width } = useContext(WindowSizeContext);
  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1025,
    isDesktop: width >= 1025,
  };
};
